import { render, staticRenderFns } from "./PageCateogry.vue?vue&type=template&id=d901ddfe"
import script from "./PageCateogry.vue?vue&type=script&lang=js"
export * from "./PageCateogry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports